
<div class="json-editor">
  <div
    ref="editorContainer"
    class="json-editor__container"
    :class="{
      'json-editor__container--disabled': disabled,
      'json-editor__container--drag-over': isDragOver
    }"
    @dragover.prevent.stop="handleDragOver"
    @dragenter.prevent.stop="handleDragEnter"
    @dragleave.prevent.stop="handleDragLeave"
    @drop.prevent.stop="handleDrop"
  >
    <!-- CodeMirror will be mounted here -->
  </div>
</div>
